/**
 * mc-whatsapp-cta.js — Manifesto (task 0031)
 *
 * Telemetria do botão "Compre pelo WhatsApp" (DP-12). Um único listener
 * DELEGADO no document cobre as instâncias das 3 superfícies (PDP,
 * harmonização, bundle), inclusive markup injetado depois da carga.
 *
 * Contrato:
 *   - NUNCA chama preventDefault: a navegação para o wa.me não depende
 *     deste script. Sem JS, o link continua funcionando 100%.
 *   - LGPD: o payload não carrega NENHUM dado pessoal — proibido telefone,
 *     mensagem, e-mail, CEP ou qualquer identificador de pessoa. Só id e
 *     handle do produto + a superfície de origem.
 */
(function () {
  'use strict';

  if (window.__mcWhatsappCtaBound) return;
  window.__mcWhatsappCtaBound = true;

  function onClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var cta = target.closest('[data-mc-wa-cta]');
    if (!cta) return;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_cta_click',
        surface: cta.getAttribute('data-surface') || '',
        position: cta.getAttribute('data-position') || '',
        product_id: cta.getAttribute('data-product-id') || '',
        product_handle: cta.getAttribute('data-product-handle') || ''
      });
    } catch (e) {
      /* telemetria nunca pode atrapalhar a navegação */
    }
  }

  // Fase de captura: garante o disparo mesmo se algum handler de terceiro
  // interromper a propagação no caminho. Não altera o comportamento do link.
  document.addEventListener('click', onClick, true);
})();
